module.exports = __webpack_public_path__ + "img/img-d4e4585d.2418a928.png";